<div id="mobile-soil-card" class="w-100 h-100">

  <!-- Embed PDF File -->
  <iframe class="w-100 h-100" [src]="dialogData?.data?.soilHealthCard[0]?.url | prefixDomain | safe: 'resourceUrl'"></iframe>

</div>
